import {CoverLinkType} from '../models'
import {Endpoint, MakeRequest, RestResponse} from './request'
import type {Secure} from '../helpers/userSecure'
import type {AppStorage} from '../index'
import axios from 'axios'
import type {DeeplinkUtils} from '../utils/deeplink'

const FIREBASE_API_KEY = 'AIzaSyAkw1JlCOKOU-AIsBfpl3onL0m46DaydRQ'

export class SystemApi {
  constructor(
    private request: MakeRequest,
    private storage: AppStorage,
    private secure: Secure,
    private deeplinkUtils: DeeplinkUtils,
  ) {}

  restCoverLink = async (
    link: string,
    hashLink: string,
    type: CoverLinkType,
  ): Promise<string | null> => {
    const response = await this.request.requestData<{data: {link: string}}>({
      wrapInQuery: true,
      api: Endpoint.coverLink,
      body: {
        link: encodeURIComponent(link),
        hash: this.storage.userHash ?? '',
        auth_type: 1,
        secur: this.secure.createUserSecure(),
        link_type: type,
        hash_link: hashLink,
      },
    })
    return response.result?.data?.link ?? null
  }

  buildFirebaseShortLink = async (longLink: string): Promise<string | null> => {
    try {
      const response = await axios.post(
        `https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=${FIREBASE_API_KEY}`,
        JSON.stringify({longDynamicLink: longLink}),
        {timeout: 10000, headers: {'Content-Type': 'application/json'}},
      )
      if (!response.data) return null
      const data = response.data as {shortLink?: string}
      return data.shortLink ? data.shortLink : null
    } catch (e) {
      console.log(e)
      return null
    }
  }

  generateProductDeepLink = async (
    linkHash: string,
    productId: string,
    ownerId: string,
  ): Promise<string | null> => {
    const rawLink = this.deeplinkUtils.generateProductLink(
      linkHash,
      productId,
      ownerId,
    )
    return this.restCoverLink(rawLink, linkHash, CoverLinkType.shareAdvert)
  }

  generateUserDeepLink = async (
    linkHash: string,
    userId: string,
  ): Promise<string | null> => {
    const rawLink = this.deeplinkUtils.generateUserLink(linkHash, userId)
    return this.restCoverLink(
      rawLink,
      linkHash,
      CoverLinkType.shareOtherProfile,
    )
  }

  recognizeWebLink = async (url: string): Promise<string | null> => {
    const response = await this.request.requestData<{
      data: string
      status: number
    }>({
      api: Endpoint.recognizeWebLink,
      method: 'POST',
      wrapInQuery: true,
      body: {url},
    })
    console.log('🔦 RESPONSE', response)
    return response.result?.data ?? null
  }

  sendToClickHouse = async (sessionId: string, eventType: string, data: any) =>
    this.request.newRequest<undefined>({
      endpoint: 'v2/statistics/event',
      body: {sessionId, eventType, data},
    })

  getDeepLink = (url: string): Promise<RestResponse<{url: string}>> => {
    return this.request.newRequest<{url: string}>({
      endpoint: 'v2/cover_link',
      body: {url},
    })
  }
}
